export default "__VITE_PUBLIC_ASSET__594574b1__"